// English is the source of truth. Every key here must exist in es.ts (enforced by the type there).
export const en = {
  appName: 'EAT Photo Booth',
  openFolder: 'Open folder',
  recent: 'Recent',
  recentFolders: 'Recent folders',
  noFolder: 'No folder open',
  photoCount: '{n} photos',
  export: 'Export',
  help: 'Help',
  language: 'Language',
  history: 'History',
  presets: 'Presets',
  filmstripEmpty: 'Open a folder of JPG, PNG, HEIC or TIFF photos to start.',
  viewerEmpty: 'No photo selected',
  viewerOpen: 'Open photo',
  autoFix: 'Auto fix',
  panelLight: 'Light',
  panelWhiteBalance: 'White balance',
  panelColor: 'Color',
  panelHsl: 'HSL',
  panelCurve: 'Tone curve',
  panelDetail: 'Detail',
  panelGeometry: 'Geometry',
  panelBackground: 'Background',
  panelMasks: 'Masks',
  panelHeal: 'Heal',
  panelSkin: 'Skin',
  panelCleanWhites: 'Clean whites',
  panelFood: 'Food looks',
  panelPresets: 'Presets',
  collapse: 'Collapse',
  expand: 'Expand',
  unsupportedTitle: 'This browser is not supported',
  unsupportedBody: 'Use Chrome or Edge on a laptop or desktop computer.',
  unsupportedMissing: 'Missing: {list}',
  close: 'Close',
  updateReady: 'A new version of the app is ready.',
  isolationReady: 'Restart the app to finish installing it (background removal gets faster).',
  reloadNow: 'Reload now',
  exposure: 'Exposure',
  contrast: 'Contrast',
  highlights: 'Highlights',
  shadows: 'Shadows',
  whites: 'Whites',
  blacks: 'Blacks',
  temp: 'Temperature',
  tint: 'Tint',
  eyedropper: 'Pick neutral',
  eyedropperHint: 'Click a neutral gray or white area',
  angle: 'Angle',
  aspect: 'Aspect',
  aspectFree: 'Free',
  aspectOriginal: 'Original',
  aspectIgSquare: 'Instagram square 1:1',
  aspectIgPortrait: 'Instagram portrait 4:5',
  aspectStory: 'Story 9:16',
  aspectDish: 'Dish card 1:1',
  constrain: 'Constrain crop',
  cropTool: 'Crop & straighten',
  straighten: 'Straighten',
  straightenHint: 'Draw a line along the horizon or a vertical edge',
  done: 'Done',
  amount: 'Amount',
  reset: 'Reset',
  zoomFit: 'Fit',
  zoom100: '100%',
  before: 'Before',
  after: 'After',
  split: 'Split view',
  clipping: 'Clipping',
  undo: 'Undo',
  redo: 'Redo',
  histogram: 'Histogram',
  zoomNote: 'Zoom to 100% to judge sharpening and noise',
  openFiles: 'Open photos',
  decoding: 'Opening…',
  decodeFailed: 'Could not open {name}: {reason}',
  doubleClickReset: 'Double-click to reset',
  exportTitle: 'Export photo',
  format: 'Format',
  quality: 'Quality',
  bitDepth: 'Bit depth',
  colorSpace: 'Color space',
  size: 'Size',
  sizeOriginal: 'Original size',
  sizeLongEdge: 'Long edge (px)',
  dpi: 'Resolution (dpi)',
  outputSharpen: 'Output sharpening',
  sharpenNone: 'None',
  sharpenScreen: 'Screen',
  sharpenMatte: 'Matte paper',
  sharpenGlossy: 'Glossy paper',
  amountLow: 'Low',
  amountStandard: 'Standard',
  amountHigh: 'High',
  metadata: 'Metadata',
  metaKeepAll: 'Keep all',
  metaStripGps: 'Remove location',
  metaCopyrightOnly: 'Copyright only',
  metaStripAll: 'Remove all',
  jpegFlattenNote:
    'JPEG has no transparency: transparent areas are filled with the fill colour (white by default).',
  exportNow: 'Export',
  cancel: 'Cancel',
  exporting: 'Exporting…',
  exportDone: 'Saved {name} ({w}×{h}, {ms} ms)',
  exportFailed: 'Export failed: {reason}',
  recentEmpty: 'No recent folders',
  fallbackBanner: "Your browser can't save next to your photos. Exports download as a zip.",
  dropFolder: 'Drop a folder to open it',
  filter: 'Filter',
  filterAll: 'All',
  filterPicks: 'Picks',
  filterRejected: 'Rejected',
  filterEdited: 'Edited',
  filterStars: '★ {n} or more',
  rating: 'Rating',
  stars: '{n} stars',
  rejected: 'Rejected',
  edited: 'Edited',
  bgRemoved: 'Background removed',
  sidecarMismatch: 'Settings file belongs to a different version of this photo and was ignored',
  sidecarLocked:
    'Settings file was made by a newer version of this app, or could not be read. It is kept as it is: changes to this photo are not saved.',
  cullView: 'Cull view',
  exitCull: 'Exit cull view',
  autoAdvance: 'Auto-advance',
  selectedCount: '{n} selected',
  permissionNeeded: 'Allow access to "{name}" to open it',
  groupCrop: 'Crop & straighten',
  groupPerspective: 'Perspective',
  groupLut: 'LUT profile',
  syncTitle: 'Choose what to copy',
  copySettings: 'Copy settings',
  pasteSettings: 'Paste settings',
  pastedN: 'Pasted to {n} photos',
  undoPasteN: 'Undo paste to {n} photos',
  copied: 'Settings copied',
  ok: 'OK',
  selectAllGroups: 'All',
  selectNoGroups: 'None',
  matchedN: 'Exposure matched on {n} photos',
  matchExposure: 'Match exposure',
  matchExposureHint: 'Uses the active photo as the reference for the other selected photos',
  autoFixDone: 'Auto fix applied',
  savePreset: 'Save current look',
  presetName: 'Preset name',
  applyPreset: 'Apply to selected',
  importPreset: 'Import…',
  exportPresetFile: 'Export file',
  deletePreset: 'Delete',
  noPresets: 'No saved presets yet',
  presetImportFailed: 'Could not import: {reason}',
  presetApplied: 'Preset applied to {n} photos',
  builtIn: 'Built-in',
  exportPresets: 'Export presets',
  scope: 'Photos',
  scopeSelected: 'Selected ({n})',
  scopePicks: 'All picks ({n})',
  scopeAll: 'All ({n})',
  destination: 'Destination',
  destFolder: 'exports folder next to the photos',
  destZip: 'Zip file',
  rename: 'Rename',
  renameTemplate: 'Name template',
  renameTokens: 'Tokens: {client} {event} {seq:3} {orig} {date} {menu} {preset}',
  client: 'Client',
  event: 'Event',
  dishNames: 'Menu (one dish per line)',
  dishPreview: 'Names in filmstrip order',
  watermark: 'Watermark',
  wmText: 'Text',
  wmLogo: 'Logo (PNG)',
  wmChooseLogo: 'Choose logo…',
  wmSize: 'Size (% of short edge)',
  wmOpacity: 'Opacity',
  wmPosition: 'Position',
  wmMargin: 'Margin (%)',
  wmColor: 'Colour',
  metadataOverride: 'Metadata',
  metaFromPreset: 'As in each preset',
  specNote: "Check the app's current spec",
  progress: '{done} of {total}',
  eta: 'about {s} s left',
  cancelling: 'Cancelling after this file…',
  batchDone: 'Exported {n} files in {s} s',
  batchCancelled: 'Cancelled: {n} files exported',
  batchFailures: '{n} failed:',
  noPresetChosen: 'Choose at least one export preset',
  duplicate: 'Duplicate',
  posTL: 'Top left',
  posTC: 'Top centre',
  posTR: 'Top right',
  posML: 'Middle left',
  posC: 'Centre',
  posMR: 'Middle right',
  posBL: 'Bottom left',
  posBC: 'Bottom centre',
  posBR: 'Bottom right',
  // M7 colour and detail panels
  vibrance: 'Vibrance',
  saturation: 'Saturation',
  hslHue: 'Hue',
  hslSat: 'Saturation',
  hslLum: 'Luminance',
  bandRed: 'Red',
  bandOrange: 'Orange',
  bandYellow: 'Yellow',
  bandGreen: 'Green',
  bandAqua: 'Aqua',
  bandBlue: 'Blue',
  bandPurple: 'Purple',
  bandMagenta: 'Magenta',
  curveMaster: 'RGB',
  curveR: 'Red',
  curveG: 'Green',
  curveB: 'Blue',
  curveHint: 'Click to add a point, drag to move it, double-click a point to remove it',
  curveReset: 'Reset curve',
  sharpAmount: 'Sharpen amount',
  sharpRadius: 'Radius',
  sharpMasking: 'Masking',
  nrLuma: 'Noise reduction',
  nrColor: 'Color noise',
  // M8 local tools
  addLinear: 'Linear',
  addRadial: 'Radial',
  addBrush: 'Brush',
  addMaskHint: 'Add a mask:',
  maskLinear: 'Linear mask {n}',
  maskRadial: 'Radial mask {n}',
  maskBrush: 'Brush mask {n}',
  maskInvert: 'Invert',
  maskDelete: 'Delete mask',
  maskOverlay: 'Show mask overlay (O)',
  maskLimit: 'Up to 8 masks per photo',
  maskEdit: 'Edit on photo',
  maskHintLinear: 'Drag on the photo to draw the gradient; drag the dots to adjust it',
  maskHintRadial: 'Drag on the photo to draw an ellipse; drag the dots to resize or rotate it',
  maskHintBrush: 'Paint on the photo; hold Alt to erase',
  maskFeather: 'Feather',
  brushSize: 'Brush size',
  brushFeather: 'Brush feather',
  brushFlow: 'Flow',
  healTool: 'Heal / clone brush',
  healModeHeal: 'Heal',
  healModeClone: 'Clone',
  healHint:
    'Paint over a spot. Alt-click first to choose the source; drag the circles to move a spot or its source',
  healCount: '{n} spots',
  healClear: 'Remove all spots',
  healUndoLast: 'Remove last spot',
  opacity: 'Opacity',
  skinTool: 'Skin brush',
  skinHint: 'Paint over skin to smooth blotches; texture is kept. Alt erases',
  skinClear: 'Clear skin strokes',
  cleanWhitesWhole: 'Whole photo',
  cleanWhitesBrush: 'Only where painted',
  cleanWhitesHint: 'Brightens and neutralizes near-white plates and backgrounds; food colours are untouched',
  cleanWhitesTool: 'Paint areas',
  // M9 background removal
  bgRemove: 'Remove background',
  bgRemoveN: 'Remove background on {n} selected',
  bgOff: 'Off',
  bgAuto: 'Auto',
  bgKey: 'Key backdrop',
  bgModel: 'Model',
  bgModelAuto: 'Fast (recommended)',
  bgModelIsnet: 'IS-Net: sharper edges, slower',
  bgLoading: 'Loading the background model…',
  bgRunning: 'Finding the subject…',
  bgModelError: 'The background model could not be loaded. Key mode and the refine brush still work.',
  bgDone: 'Done with {model} ({ep}) in {s} s',
  bgKeyPick: 'Pick backdrop colour',
  bgKeyColor: 'Backdrop colour',
  bgKeyHint: 'Click the backdrop in the photo to pick its colour',
  bgTolerance: 'Tolerance',
  bgSoftness: 'Softness',
  bgConnected: 'Only backdrop touching the edges (keeps a white plate on a white backdrop)',
  bgRefine: 'Refine',
  bgRefineBrush: 'Refine brush',
  bgKeep: 'Keep',
  bgRemoveStroke: 'Remove',
  bgRefineHint: 'Paint to keep or remove areas; Alt switches between the two',
  bgEdge: 'Edge',
  bgFeather: 'Feather',
  bgShift: 'Shift edge',
  bgDecontaminate: 'Decontaminate',
  bgView: 'Show',
  bgViewChecker: 'Checkerboard',
  bgViewWhite: 'On white',
  bgViewBlack: 'On black',
  bgViewMask: 'Mask overlay',
  bgViewMatte: 'Matte',
  bgFill: 'Fill',
  bgTransparent: 'Transparent',
  bgWhite: 'White',
  bgColor: 'Fill colour',
  bgShadow: 'Drop shadow',
  bgShadowBlur: 'Shadow softness',
  bgShadowOffset: 'Shadow offset',
  // M10
  vertical: 'Vertical perspective',
  horizontal: 'Horizontal perspective',
  panelLut: 'LUT',
  lutImport: 'Import .cube…',
  lutNone: 'None',
  lutIntensity: 'Intensity',
  lutDelete: 'Remove this LUT',
  lutError: 'Could not read {name}: {reason}',
  importXmp: 'Import Lightroom .xmp…',
  xmpReportTitle: 'Imported "{name}"',
  xmpApprox: 'Lightroom scales differ from ours, so values are mapped approximately. Check the result.',
  xmpMapped: 'Applied ({n}):',
  xmpIgnored: 'Not applied ({n}):',
  foodHint: 'Starting points for menu photos; adjust to taste.',
  metadataButton: 'Metadata…',
  metadataTitle: 'Metadata written into exports',
  metaArtist: 'Artist',
  metaCopyright: 'Copyright',
  metaEmail: 'Email',
  metaWebsite: 'Website',
  metaHint: 'Applied according to each export preset (keep all, strip GPS, copyright only, strip all).',
  save: 'Save',
  contactSheet: 'Contact sheet (PDF)',
  contactPaper: 'Paper',
  contactA4: 'A4',
  contactLetter: 'Letter',
  contactClient: 'Client',
  contactEvent: 'Event',
  contactPage: 'Page {n} of {total}',
  contactPhotos: '{n} photos',
  // M11a effects
  panelEffects: 'Effects',
  vignette: 'Vignette',
  vignetteAmount: 'Vignette amount',
  vignetteMidpoint: 'Midpoint',
  vignetteFeather: 'Feather',
  grain: 'Grain',
  grainAmount: 'Grain amount',
  grainSize: 'Grain size',
  splitTone: 'Split toning',
  stShadowHue: 'Shadow hue',
  stShadowSat: 'Shadow saturation',
  stHighlightHue: 'Highlight hue',
  stHighlightSat: 'Highlight saturation',
  stBalance: 'Balance',
  // M11a simple mode
  proMode: 'Pro mode',
  simpleOpen: 'Open photo',
  simpleOpenFolder: 'or open a folder',
  stepOpen: 'Open',
  stepClean: 'Clean up',
  stepFilter: 'Filters',
  stepBackground: 'Background',
  stepSave: 'Save',
  strength: 'Strength',
  undoBig: 'Undo',
  startOver: 'Start over',
  holdOriginal: 'Hold to see the original',
  clFixLighting: 'Fix lighting',
  clFixColors: 'Fix colors',
  clBrighten: 'Brighten',
  clTameSky: 'Tame highlights',
  clCleanPlate: 'Clean plate',
  clSharpen: 'Sharpen',
  clReduceGrain: 'Reduce grain',
  clStraighten: 'Straighten',
  clRemoveSpots: 'Remove spots',
  clCropFor: 'Crop for…',
  clRemoveBackground: 'Remove background',
  clNothing: 'Nothing to fix here',
  clNoLine: "Couldn't find a straight line",
  clSpotsHint: 'Tap each spot to remove it',
  clCropHint: 'Drag the photo to place it inside the frame',
  cropSquare: 'Square (Instagram)',
  cropPortrait: 'Portrait 4:5',
  cropStory: 'Story 9:16',
  cropMenu: 'Menu 3:2',
  fgFood: 'Food',
  fgEveryday: 'Everyday',
  fgMood: 'Mood',
  fgPeople: 'People',
  fgBw: 'Black & White',
  noFilter: 'No filter',
  bgTransparent2: 'Transparent',
  saveInstagram: 'Instagram',
  saveWhatsapp: 'WhatsApp',
  saveMenu: 'Menu',
  saveDelivery: 'Delivery app',
  savePng: 'No background (PNG)',
  wsPhotos: 'Photos',
  wsDesign: 'Ads',
  workspace: 'Workspace',
  designDocName: 'Document name',
  designNewOrOpen: 'New / open…',
  designSaved: 'Saved',
  designSaving: 'Saving…',
  designSaveFailed: 'Could not save',
  designUnsaved: 'Not saved yet',
  designSave: 'Save',
  designTools: 'Tools',
  designHintNone: 'Choose a tool on the left.',
  dockEmpty: 'Select something to see its settings here.',
  designNewDoc: 'New design',
  designUntitled: 'Untitled',
  designMine: 'Your designs',
  designNone: 'No designs yet.',
  historyOpen: 'Open',
  dockProperties: 'Properties',
  dockLayers: 'Layers',
  dockAppearance: 'Appearance',
  dockSwatches: 'Swatches',
  dockType: 'Character & paragraph',
  dockArrange: 'Align & transform',
  dockArtboards: 'Artboards',
  dockSymbols: 'Symbols',
  dockMenu: 'Menu',
  dockHistory: 'History',
  cmdAdd: 'Add',
  cmdDelete: 'Delete',
  cmdEdit: 'Edit',
  cmdTransform: 'Transform',
  cmdRename: 'Rename',
  cmdAddLayer: 'New layer',
  cmdLayer: 'Layer',
  cmdDeleteLayer: 'Delete layer',
  cmdAddArtboard: 'New artboard',
  cmdArtboard: 'Artboard',
  cmdDeleteArtboard: 'Delete artboard',
  toolSelect: 'Selection',
  toolDirect: 'Direct selection',
  toolLasso: 'Lasso',
  toolPen: 'Pen',
  toolCurvature: 'Curvature',
  toolPencil: 'Pencil',
  toolAddAnchor: 'Add anchor point',
  toolDeleteAnchor: 'Delete anchor point',
  toolConvertAnchor: 'Convert anchor point',
  toolScissors: 'Scissors',
  toolKnife: 'Knife',
  toolRect: 'Rectangle',
  toolEllipse: 'Ellipse',
  toolPolygon: 'Polygon',
  toolStar: 'Star',
  toolLine: 'Line segment',
  toolType: 'Type',
  toolAreaType: 'Area type',
  toolPathType: 'Type on a path',
  toolRotate: 'Rotate',
  toolReflect: 'Reflect',
  toolScale: 'Scale',
  toolShear: 'Shear',
  toolEyedropper: 'Eyedropper',
  toolGradient: 'Gradient',
  toolArtboard: 'Artboard',
  toolHand: 'Hand',
  toolZoom: 'Zoom',
  hintSelect: 'Click to select, drag to move; drag a handle to scale, outside a corner to rotate.',
  hintDirect: 'Click an anchor or a handle to edit it.',
  hintLasso: 'Drag around anchor points to select them.',
  hintPen: 'Click for corners, drag for curves; click the first point to close.',
  hintCurvature: 'Click points; the curve passes through them.',
  hintPencil: 'Drag to draw freehand.',
  hintAddAnchor: 'Click a path to add a point.',
  hintDeleteAnchor: 'Click a point to remove it.',
  hintConvertAnchor: 'Click a point to make it a corner; drag to make it smooth.',
  hintScissors: 'Click a path to cut it there.',
  hintKnife: 'Drag across shapes to slice them.',
  hintRect: 'Drag to draw; Shift for a square.',
  hintEllipse: 'Drag to draw; Shift for a circle.',
  hintPolygon: 'Drag from the centre.',
  hintStar: 'Drag from the centre.',
  hintLine: 'Drag to draw; Shift for 45° steps.',
  hintType: 'Click to type; drag to make a text box.',
  hintAreaType: 'Click a closed shape to type inside it.',
  hintPathType: 'Click a path to type along it.',
  hintRotate: 'Drag to rotate the selection.',
  hintReflect: 'Click to mirror the selection.',
  hintScale: 'Drag to scale the selection.',
  hintShear: 'Drag to slant the selection.',
  hintEyedropper: 'Click an object to copy its look.',
  hintGradient: 'Drag across the selection to set the gradient.',
  hintArtboard: 'Drag to make or move artboards.',
  hintHand: 'Drag to move around (or hold Space with any tool).',
  hintZoom: 'Click to zoom in, Alt-click to zoom out.',
  kindPath: 'Path',
  kindShape: 'Shape',
  kindText: 'Text',
  kindImage: 'Image',
  kindGroup: 'Group',
  kindSymbol: 'Symbol',
  layerN: 'Layer {n}',
  newLayer: 'New layer',
  deleteLayer: 'Delete layer',
  showHide: 'Show / hide',
  lockUnlock: 'Lock / unlock',
  layerName: 'Layer name',
  objectName: 'Object name',
  targetIndicator: 'Holds selected objects',
  moreObjects: '… and {n} more objects',
  refPoint: 'Reference point',
  width: 'Width',
  height: 'Height',
  rotation: 'Rotation °',
  shear: 'Shear °',
  unitsAre: 'Units: {unit}',
  units: 'Units',
  cmdUnits: 'Units',
  cmdVisibility: 'Show / hide',
  cmdLock: 'Lock',
  cmdDuplicate: 'Duplicate',
  cmdGroup: 'Group',
  cmdUngroup: 'Ungroup',
  cmdArrange: 'Arrange',
  cmdMove: 'Move',
  alignCenter: 'Centre',
  alignInside: 'Inside',
  alignOutside: 'Outside',
  arrowNone: 'No arrow',
  arrowTriangle: 'Triangle',
  arrowOpen: 'Open',
  arrowCircle: 'Circle',
  arrowSquare: 'Square',
  arrowBar: 'Bar',
  arrowStart: 'Start arrowhead',
  arrowEnd: 'End arrowhead',
  arrows: 'Arrows',
  blend: 'Blend mode',
  blendNormal: 'Normal',
  blendMultiply: 'Multiply',
  blendScreen: 'Screen',
  blendOverlay: 'Overlay',
  blendDarken: 'Darken',
  blendLighten: 'Lighten',
  blendColorDodge: 'Color dodge',
  blendColorBurn: 'Color burn',
  blendHardLight: 'Hard light',
  blendSoftLight: 'Soft light',
  blendDifference: 'Difference',
  blendExclusion: 'Exclusion',
  blendHue: 'Hue',
  blendSaturation: 'Saturation',
  blendColor: 'Color',
  blendLuminosity: 'Luminosity',
  capButt: 'Butt cap',
  capRound: 'Round cap',
  capSquare: 'Projecting cap',
  joinMiter: 'Miter join',
  joinRound: 'Round join',
  joinBevel: 'Bevel join',
  cmykApprox: 'Approximate on-screen CMYK: the values you type are exported exactly.',
  color: 'Colour',
  colorMode: 'Colour mode',
  dashOffset: 'Dash offset',
  dashes: 'Dashes',
  defaultFillStroke: 'Default fill and stroke',
  deleteSwatch: 'Delete swatch',
  expandShape: 'Expand (make an editable path)',
  fill: 'Fill',
  fillBox: 'Fill',
  strokeBox: 'Stroke',
  fills: 'Fills',
  globalSwatch: 'global',
  hex: 'Hex',
  hue: 'Hue',
  innerRadius: 'Inner radius',
  outerRadius: 'Outer radius',
  miterLimit: 'Miter limit',
  newSwatch: 'New swatch',
  noneColor: 'None',
  objectLook: 'Object',
  points: 'Points',
  radius: 'Radius',
  radiusX: 'Horizontal radius',
  radiusY: 'Vertical radius',
  radius_tl: 'Top-left corner',
  radius_tr: 'Top-right corner',
  radius_br: 'Bottom-right corner',
  radius_bl: 'Bottom-left corner',
  remove: 'Remove',
  shapeOptions: 'Shape',
  sides: 'Sides',
  stroke: 'Stroke',
  strokeAlign: 'Stroke position',
  strokeCap: 'Cap',
  strokeJoin: 'Join',
  strokeWidth: 'Width',
  strokes: 'Strokes',
  swapFillStroke: 'Swap fill and stroke',
  swatchN: 'Swatch {n}',
  swatchName: 'Swatch name',
  cmdAppearance: 'Appearance',
  cmdShape: 'Shape',
  cmdExpand: 'Expand',
  cmdSwatch: 'Swatch',
  cmdSwatchDelete: 'Delete swatch',
  cmdColorMode: 'Colour mode',
  pathOps: 'Path',
  pathJoin: 'Join',
  pathAverage: 'Average',
  pathCompound: 'Make compound path',
  pathRelease: 'Release compound path',
  pathReverse: 'Reverse direction',
  pathSimplify: 'Simplify within',
  apply: 'Apply',
  cmdEditPath: 'Edit path',
  cmdScissors: 'Cut path',
  cmdKnife: 'Knife',
  cmdCompound: 'Compound path',
  cmdReleaseCompound: 'Release compound path',
  cmdGuide: 'Guide',
  cmdGuideDelete: 'Delete guide',
  alLeft: 'Align left edges',
  alHCenter: 'Align horizontal centres',
  alRight: 'Align right edges',
  alTop: 'Align top edges',
  alVCenter: 'Align vertical centres',
  alBottom: 'Align bottom edges',
  diLeft: 'Distribute left edges',
  diHCenter: 'Distribute horizontal centres',
  diRight: 'Distribute right edges',
  diTop: 'Distribute top edges',
  diVCenter: 'Distribute vertical centres',
  diBottom: 'Distribute bottom edges',
  diHSpace: 'Equal horizontal spacing',
  diVSpace: 'Equal vertical spacing',
  alignTo: 'Align to',
  alignToSelection: 'Selection',
  alignToKey: 'Key object',
  alignToArtboard: 'Artboard',
  keyHint: 'Click an object of the selection again to make it the key object.',
  distribute: 'Distribute',
  spacing: 'Spacing',
  auto: 'Auto',
  viewMenu: 'View',
  snapOn: 'Snap',
  snapGrid: 'Snap to grid',
  snapPixel: 'Snap to pixels',
  smartGuides: 'Smart guides',
  showGrid: 'Show grid',
  showGuides: 'Show guides',
  foodOriginals: 'Originals',
  foodSecFix: 'Fix the light',
  foodSecDish: 'By dish',
  foodSecStyle: 'Styles',
  foodSecMenu: 'Menu & delivery',
  bgFailedSimple: 'The background could not be removed from this photo. Please try again.',
  errUnsupported: 'this kind of file cannot be opened',
  errCorrupt: 'the file is damaged or incomplete',
  errHeic: 'HEIC photos cannot be opened in this browser',
  errZipTooLarge: 'the zip would be larger than 3.5 GB. Export to a folder instead',
  errGpuReset: 'the graphics card was reset. Please try again',
  errWorker: 'part of the app did not load. Please reload the page',
  errNotXmp: 'this is not a Lightroom or Camera Raw preset',
  errRefused: 'that name belongs to an original photo, so it was not written',
  errGeneric: 'something went wrong. Please try again',
  xmpAbsTemp: 'absolute temperature (Kelvin) is not used for JPEGs here; use IncrementalTemperature',
  xmpAbsTint: 'absolute tint is not used; use IncrementalTint',
  xmpWbMode: 'the white balance mode is not imported',
  xmpNoTexture: 'there is no texture control',
  xmpNoClarity: 'there is no clarity control',
  xmpNoDehaze: 'there is no dehaze control',
  xmpNoVignette: 'the vignette is not imported',
  xmpNoGrain: 'the grain is not imported',
  xmpNoControl: 'no matching control',
  xmpNotNumber: 'not a number: "{raw}"',
  xmpPoints: '{n} points',
  saveOriginal: 'Original size',
  saved: 'Saved {name}',
  saveFailed: 'Could not save: {reason}',
  // M11b
  about: 'About',
  aboutTitle: 'About EAT Photo Booth',
  aboutText:
    'A free, offline food photo, styling and ad studio. Everything runs on this computer and originals are never changed. Background removal and Make bigger use small models stored with the app. Photos leave this computer only if you set your own AI key and press an AI button.',
  aboutVersion: 'Version {v}',
  aboutModels: 'AI models (on this computer)',
  aboutLicenses: 'Open-source software included ({n} packages)',
  aboutLgpl: 'libheif-js (LGPL-3.0) is loaded as a separate WebAssembly module, only to read HEIC photos.',
  cheatTitle: 'Keyboard shortcuts',
  kPrevNext: 'Previous / next photo',
  kRate: 'Star rating',
  kReject: 'Reject',
  kCull: 'Cull view',
  kBefore: 'Before / after (tap or hold)',
  kSplit: 'Split before/after view',
  kClipping: 'Clipping warning',
  kZoom: 'Zoom fit / 100%',
  kCrop: 'Crop tool',
  kMaskOverlay: 'Show mask overlay',
  kRemoveBg: 'Remove background',
  kBgView: 'Background view (checker, white, black, mask, matte)',
  kCopy: 'Copy settings (Shift: choose groups)',
  kPaste: 'Paste settings to the selection (Shift: choose groups)',
  kUndoRedo: 'Undo / redo',
  kExport: 'Export',
  kAlt: 'Fine slider steps; erase with brushes; heal source',
  kPan: 'Hold and drag to pan at 100%',
  kEscEnter: 'Leave a tool / the cull view',
  kCheat: 'This list',
  helpTopic: 'Help: {topic}',
  makeBigger: 'Make bigger',
  makeBigger2: '2×',
  makeBigger4: '4×',
  makeBiggerOff: 'Original size',
  makeBiggerSize: '{w} × {h} px → {W} × {H} px',
  makeBiggerTooLarge: 'This photo is already as big as it can get (24 MP).',
  makeBiggerRunning: 'Enlarging… {done} of {total}',
  makeBiggerDone: 'Enlarged to {w} × {h} px',
  makeBiggerFailed: 'Could not enlarge this photo: {reason}',
  panelUpscale: 'Upscale',
  upscaleFactor: 'Size',
  upscaleModel: 'Model',
  upscaleModelGeneral: 'General (fast, built in)',
  upscaleModelPlus: 'Photo x4plus (sharper, slower)',
  upscaleModelMissing: 'Not installed (npm run fetch-models -- esrgan-plus)',
  upscaleStrength: 'Strength',
  upscaleStrengthHint: "Low keeps the photo's own texture; high cleans noise and JPEG blocks more.",
  upscaleApply: 'Apply',
  upscaleNote: 'The enlarged pixels are made by an AI model on this computer. Nothing is uploaded.',
  aboutUpscaleModels: 'Upscale models',
  dockAd: 'Ad',
  cmdApplyBrand: 'Apply brand',
  cmdEditAd: 'Edit ad text',
  cmdFillPhoto: 'Place photo',
  makeAd: 'Make an ad',
  makeAdHint: 'Put this photo in a ready-made ad with your logo and prices.',
  adPickTemplate: 'Pick a template',
  adMyBrand: 'My brand',
  adBackToAd: 'Back to my ad',
  adWithPhoto: 'It will use the photo {name}.',
  adNoPhoto: 'No photo open: the photo space stays empty until you add one.',
  adWorking: 'Working…',
  adTemplates: 'Templates',
  adTemplatesStart: 'Make an ad from a template',
  adPreparingPhoto: 'Preparing the photo…',
  adNotAnAd: 'This design is not an ad template. Pick a template to get the ad form.',
  adText: 'Text',
  adDishName: 'Dish name',
  adDescription: 'Description',
  adHeadline: 'Headline',
  adTagline: 'Small line',
  adSpanish: 'Spanish',
  adEnglish: 'English',
  adPrice: 'Price',
  adOldPrice: 'Before (crossed out)',
  adPriceShows: 'Shows as {p}',
  adMenuItems: 'Menu items',
  adPhoto: 'Photo',
  adUseCurrentPhoto: 'Use the photo I am editing',
  adChoosePhoto: 'Or choose another photo',
  adPhotoFromFile: 'Photo from a file…',
  adPhotoZoom: 'Zoom',
  adPhotoLeftRight: 'Left / right',
  adPhotoUpDown: 'Up / down',
  adPhotoWhole: 'Show the whole photo (no crop)',
  adSave: 'Save',
  adPngSize: 'PNG size',
  adSavePng: 'Save PNG',
  adSavePdf: 'Save PDF (for printing)',
  adTextObject: 'Selected text',
  adTextBound: 'Shows the ad field "{field}" ({lang}); change it in the form below.',
  adTextContent: 'Text',
  adFont: 'Font',
  adWeight: 'Weight',
  adSize: 'Size',
  adColor: 'Colour',
  adAlign: 'Alignment',
  adLines: 'Max lines',
  adTracking: 'Letter spacing',
  adLeading: 'Line height',
  adCaps: 'ALL CAPS',
  adShrunk: 'Shrunk to {size} to fit its box.',
  adOverflow: 'The text does not fit even at the smallest size; it ends in "…".',
  alignLeftShort: 'Left',
  alignCenterShort: 'Centre',
  alignRightShort: 'Right',
  brandIntro: 'Set this once: every template uses your name, logo, colours and fonts.',
  brandName: 'Restaurant name',
  brandContact: 'Contact line (phone, address or web)',
  brandContactHint: 'WhatsApp 5555-0000 · 4a Calle 1-23',
  brandLogo: 'Logo (a PNG with a transparent background looks best)',
  brandLogoRemove: 'Remove logo',
  brandColors: 'Brand colours',
  brandPrimary: 'Main',
  brandSecondary: 'Second',
  brandAccent: 'Accent',
  brandBackground: 'Background',
  brandText: 'Text',
  brandHeadingFont: 'Font for titles',
  brandBodyFont: 'Font for text',
  brandCurrency: 'Currency symbol',
  brandDecimals: 'Decimals',
  brandSymbolAfter: 'Symbol after the number',
  brandSave: 'Save my brand',
  brandDefaults: 'Reset to default',
  aiButton: 'AI',
  aiSettings: 'AI with your own key',
  aiIntro:
    'Optional. Everything in the app works without a key. With an OpenAI or Google key you get a smart fix, ad text in English and Spanish, and AI touch-up.',
  aiKey: 'API key',
  aiKeyPlaceholder: 'Paste your key here',
  aiKeyStored:
    'The key is kept only in this browser. It is never logged and never written into your photos, designs or exports.',
  aiModels: 'Model names (advanced)',
  aiModelVision: 'Text and smart fix:',
  aiModelImage: 'Images:',
  aiPrivacy:
    "A photo is sent to the provider only when you press an AI button, straight from this browser. The provider's prices and terms apply.",
  aiSave: 'Save',
  aiRemoveKey: 'Remove key',
  aiKeySet: 'Key set: {provider} ({key})',
  aiNoKey: 'No key set: AI buttons are hidden and nothing is sent anywhere.',
  aiSmartFix: 'Smart fix (AI)',
  aiTouchUp: 'AI touch-up',
  aiUpscale: 'AI upscale',
  aiSendsPhoto: 'These buttons send a small copy of the photo to your AI provider.',
  aiFailed: 'AI did not work: {reason}',
  aiCompareTitle: 'AI result next to the original',
  aiOriginal: 'Original (your photo)',
  aiGenerated: 'AI-generated',
  aiDeliveryNote:
    'Delivery apps require photos of the real dish. An AI-made image may show things that are not on the plate; use it with care and never instead of a real photo where a real one is required.',
  aiSaveCopy: 'Save the AI version as a new file',
  aiWriteText: 'Write the text with AI',
  panelAi: 'AI (your key)',
  wsPlating: 'Plating',
  platingGuide: 'Plating guide',
  platingTitle: 'Plating and photo guides',
  platingIntro: 'Print a card for the kitchen: how to plate the dish and how to photograph it.',
  platingMine: 'My cards',
  platingBuiltIn: 'Ready-made cards',
  platingNoneYet: 'None yet: duplicate a card to make your own.',
  platingLanguage: 'Language on the card',
  platingBoth: 'Both (Spanish / English)',
  platingSavePdf: 'Save PDF (to print)',
  platingDuplicate: 'Duplicate to make my own',
  platingCopy: 'Make a copy',
  platingDelete: 'Delete this card',
  platingExportFile: 'Save card file (to share)',
  platingImportFile: 'Open a card file',
  platingCardName: 'Card name (your dish)',
  platingPlate: 'Plate',
  platingAngle: 'Camera angle',
  platingElements: 'On the plate',
  platingDragHint: 'Drag the shapes on the drawing to move them.',
  platingRemove: 'Remove',
  platingRotate: 'Turn',
  platingAddElement: 'Add an item',
  platingLight: 'Lighting tip',
  platingSteps: 'Steps',
  platingStepsHint: 'One step per line.',
  platingPhoto: 'Reference photo',
  platingPhotoRemove: 'Remove photo',
  aboutFonts: 'Fonts (for ads)',
  themeDark: 'Dark theme',
  themeLight: 'Light theme',
  appShort: 'Photo Booth',
  helpPages: 'Help pages',
  stepOf: 'Step {n} of {total}',
  stepBack: 'Back',
  stepNext: 'Next',
  saveBig: 'Save',
  filtersSampleHint: 'Open a photo to try these filters',
  noticeDismiss: 'Dismiss',
  moreOptions: 'More',
} as const;

export type MessageKey = keyof typeof en;
